import { Component } from '@angular/core'
import { RootState, setCommandsMetrics } from '@helios/state-management'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'

@Component({
  selector: 'hs-transaction-delete-modal',
  templateUrl: './transaction-delete-modal.component.html',
  styleUrls: ['./transaction-delete-modal.component.scss'],
})
export class TransactionDeleteModalComponent {
  toDelete?: string[]
  constructor(
    public activeModal: NgbActiveModal,
    private readonly store: Store<RootState>,
  ) {}
  delete() {
    this.store.dispatch(
      setCommandsMetrics({
        command: 'delete',
        time: Date.now(),
      }),
    )
    this.activeModal.close()
  }
}
